<template>
	<div class="content">
		<LayoutBanner />

		<div v-loading="loading" class="recruit min_cw">
			<div class="top">
				<h2 class="title">诚聘英才</h2>
			</div>

			<el-collapse accordion>
				<el-collapse-item v-for="(item, index) in list" :key="item.recruit_id">
					<template slot="title">
						<div class="collapse_item">
							<span class="title">{{ item.post_name }}</span>
							<span class="date">{{ $formatDate(item.create_time, 'date') }}</span>
						</div>
					</template>

					<div v-if="item.post_name" class="collapse_con_item">
						<h2 class="title">{{ getSortNum(item.sortArr, "post_name") }}、岗位名称</h2>
						<div class="con" v-html="textToHtml(item.post_name)"></div>
					</div>

					<div v-if="item.requirements" class="collapse_con_item">
						<h2 class="title">{{ getSortNum(item.sortArr, "requirements") }}、岗位要求</h2>
						<div class="con" v-html="textToHtml(item.requirements)"></div>
					</div>

					<div v-if="item.responsibilities" class="collapse_con_item">
						<h2 class="title">{{ getSortNum(item.sortArr, "responsibilities") }}、岗位职责</h2>
						<div class="con" v-html="textToHtml(item.responsibilities)"></div>
					</div>

					<div v-if="item.place" class="collapse_con_item">
						<h2 class="title">{{ getSortNum(item.sortArr, "place") }}、工作地点</h2>
						<div class="con" v-html="textToHtml(item.place)"></div>
					</div>

					<div v-if="item.people_number" class="collapse_con_item">
						<h2 class="title">{{ getSortNum(item.sortArr, "people_number") }}、招聘人数</h2>
						<div class="con" v-html="textToHtml(item.people_number)"></div>
					</div>

					<div v-if="item.benefits" class="collapse_con_item">
						<h2 class="title">{{ getSortNum(item.sortArr, "benefits") }}、福利待遇</h2>
						<div class="con" v-html="textToHtml(item.benefits)"></div>
					</div>

					<div v-if="item.education" class="collapse_con_item">
						<h2 class="title">{{ getSortNum(item.sortArr, "education") }}、学历要求</h2>
						<div class="con" v-html="textToHtml(item.education)"></div>
					</div>

					<div v-if="item.contact_user || item.phone || item.mail" class="collapse_con_item">
						<h2 class="title">{{ getSortNum(item.sortArr, "contact_user") }}、联系方式</h2>
						<div class="con">
							<p v-if="item.contact_user">联系人：{{ item.contact_user }}</p>
							<p v-if="item.phone">联系电话：{{ item.phone }}</p>
							<p v-if="item.mail">电子邮箱：{{ item.mail }}</p>
						</div>
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>
	</div>
</template>

<script>
import LayoutBanner from "@/components/Layout/banner";
import {getRecruitInfoListApi} from "@/api";

export default {
	name: "index",
	components: {
		LayoutBanner,
	},
	data() {
		return {
			loading: false,
			list: [],

			sortNum: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"],
		}
	},
	created() {
		this.getList();
	},
	methods: {
		async getList() {
			this.loading = true;
			const res = await getRecruitInfoListApi();
			res.data.forEach(item => {
				let sortArr = [];
				if(item.post_name) sortArr.push("post_name"); // 岗位名称
				if(item.requirements) sortArr.push("requirements"); // 岗位要求
				if(item.responsibilities) sortArr.push("responsibilities"); // 岗位职责
				if(item.place) sortArr.push("place"); // 工作地点
				if(item.people_number) sortArr.push("people_number"); // 招聘人数
				if(item.benefits) sortArr.push("benefits"); // 福利待遇
				if(item.education) sortArr.push("education"); // 学历要求
				if(item.contact_user || item.phone || item.mail) sortArr.push("contact_user"); // 联系方式
				item.sortArr = sortArr;
			})
			this.list = res.data;
			this.loading = false;
		},

		textToHtml(text) {
			return text ? text.replaceAll('\n', '<br>') : ''
		},

		getSortNum(sortList, name) {
			let index = sortList.indexOf(name);
			return index === -1 ? "" : this.sortNum[ sortList.indexOf(name) ]
		},
	}
}
</script>

<style lang="less" scoped>
.recruit {
	padding: 60px 40px;

	.top {
		margin-bottom: 50px;

		.title {
			font-size: 22px;
			color: @blackLine;
			line-height: 1.6;
		}
	}

	/deep/ .el-collapse-item__header {
		padding: 0 20px;
		border-left: 1px solid #EBEEF5;
		border-right: 1px solid #EBEEF5;
		background-color: #F5F7F9;
		flex-direction: row-reverse;
		height: 60px;
		line-height: 60px;
	}

	/deep/ .el-collapse-item__arrow {
		font-size: 20px;
		color: @red;
	}

	/deep/ .el-collapse-item__content {
		padding: 20px 50px;
		border-left: 1px solid #EBEEF5;
		border-right: 1px solid #EBEEF5;
	}

	.collapse_item {
		width: 100%;
		display: flex;
		justify-content: space-between;

		.title {
			font-size: 18px;
			color: @blackLine;
		}

		.date {
			font-size: 16px;
			color: #666666;
		}
	}

	.collapse_con_item {
		margin-bottom: 30px;

		.title {
			font-size: 16px;
			color: @gray;
			/*font-weight: normal;*/
		}

		.con {
			font-size: 14px;
			color: @black;
			line-height: 1.6;
			margin-top: 5px;
		}
	}
}
</style>
